"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.avatar = exports.tenants = exports.phone = exports.email = exports.lastName = exports.firstName = void 0;
var firstName = 'https://pingum.io/firstName';
exports.firstName = firstName;
var lastName = 'https://pingum.io/lastName';
exports.lastName = lastName;
var email = 'https://pingum.io/email';
exports.email = email;
var phone = 'https://pingum.io/phone';
exports.phone = phone;
var tenants = 'https://pingum.io/tenants';
exports.tenants = tenants;
var avatar = 'https://pingum.io/avatar';
exports.avatar = avatar;